import React, { useState, useEffect } from 'react';
import api from '@/utils/api';
import { Card, CardContent } from '@/components/ui/card';
import { Sparkles } from 'lucide-react';

/**
 * Gast-Trichter (2026): Gast gestartet → Tour abgeschlossen → Erste Rechnung → Konto gesichert.
 * Datenquelle: /admin/guest-funnel (Zeitstempel am User-Dokument).
 */
export default function GuestFunnelPanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get('/admin/guest-funnel');
        setData(res.data);
      } catch (e) {
        console.error('Gast-Trichter laden fehlgeschlagen:', e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading && !data) {
    return <div className="py-6 text-center text-gray-500" data-testid="guest-funnel-loading">Lade Gast-Trichter…</div>;
  }
  if (!data) return null;

  const maxCount = Math.max(...data.funnel.map((s) => s.count), 1);
  const stepColors = ['bg-slate-400', 'bg-teal-500', 'bg-emerald-500', 'bg-emerald-700'];

  return (
    <div className="space-y-4" data-testid="guest-funnel-panel">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
          <Sparkles className="h-5 w-5 text-emerald-600" />
          Gast-Trichter (Offener Einstieg)
        </h3>
        <span className="text-sm text-gray-500" data-testid="guest-funnel-conversion">
          Konversion: <span className="font-mono font-semibold text-emerald-700">{data.conversion_rate}%</span>
        </span>
      </div>

      <Card>
        <CardContent className="pt-6 space-y-4">
          {data.funnel.map((step, i) => (
            <div key={step.step} data-testid={`guest-funnel-step-${i}`}>
              <div className="flex items-baseline justify-between mb-1">
                <span className="text-sm font-medium text-gray-700">{step.step}</span>
                <span className="text-sm font-mono text-gray-900">
                  {step.count}
                  <span className="ml-2 text-xs text-gray-400">{step.rate}%</span>
                </span>
              </div>
              <div className="h-7 w-full rounded-md bg-slate-100 overflow-hidden">
                <div
                  className={`h-full rounded-md ${stepColors[i]} transition-all duration-500`}
                  style={{ width: `${Math.max((step.count / maxCount) * 100, step.count > 0 ? 2 : 0)}%` }}
                />
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
